let mmloading;
export default {
  methods: {
    showLoading() {
      mmloading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    closeLoading() {
      mmloading.close();
    }
  }
};
